export enum UsersOrganizationsPermissionsWriteType {
    IsOwner = 1,
    RevenuesWrite = 1 << 1,
    ExpensesWrite = 1 << 2,
    DonationWrite = 1 << 3,
    SponsorsWrite = 1 << 4,
    EventsWrite = 1 << 5,
    PartyNotesWrite = 1 << 6,
    BarsWrite = 1 << 7,
    DashboardWrite = 1 << 8,
}

// Máximo é Math.pow(2, 31)
